import type { FacilityFlowCoreModulesCustomersDtosCustomerListDto as CustomerListDto } from '../../../api/generated/models';

export type TabId = 'all' | 'active' | 'inactive' | 'noObjects';
export type SortId = 'name' | 'objects' | 'hours' | 'newest';
export const TAB_IDS: readonly TabId[] = ['all', 'active', 'inactive', 'noObjects'];
export const SORT_IDS: readonly SortId[] = ['name', 'objects'];

/** The customer list as shown: tab and search filter, then sort (most objects first or by name). */
export function filterCustomers(
  customers: readonly CustomerListDto[],
  { tab, search, sortBy }: { tab: TabId; search: string; sortBy: SortId },
  objectCountByCustomer: ReadonlyMap<string, number>,
): CustomerListDto[] {
  const term = search.trim().toLowerCase();
  const objectCount = (c: CustomerListDto) => objectCountByCustomer.get(c.id ?? '') ?? 0;
  return customers
    .filter((c) => {
      if (tab === 'active' && c.status !== 'active') return false;
      if (tab === 'inactive' && c.status === 'active') return false;
      if (tab === 'noObjects' && objectCount(c) > 0) return false;
      if (!term) return true;
      return (
        c.name?.toLowerCase().includes(term) ||
        c.customerNumber?.toLowerCase().includes(term) ||
        c.city?.toLowerCase().includes(term)
      );
    })
    .sort((a, b) => {
      if (sortBy === 'objects' && objectCount(a) !== objectCount(b)) return objectCount(b) - objectCount(a);
      return (a.name ?? '').localeCompare(b.name ?? '');
    });
}
